import { useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "../../../../../components/common/Input/Input";
import TelInput from "../../../../../components/common/telInput/telInput";
import TitleDescription from "../../../../../components/newMotorPolicy/titleDescription/titleDescription";
import useFileClaimFlow from "../../../../../hooks/useFileClaimFlow";
import useMotorForm from "../../../../../hooks/useMotorFormData";
import useValidation from "../../../../../hooks/useValidation";
import { PROPERTY_DAMAGE_YOUR_INFO } from "../../data";
import FileClaimMotorLayout from "../../fileClaimMotorLayout";

function BodilyInjuryYourInfo() {
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { handleNextSubstep } = useFileClaimFlow();
  const { saveMotorDataInRedux } = useMotorForm(
    PROPERTY_DAMAGE_YOUR_INFO,
    setFormData
  );
  const { errors, validateFields } = useValidation();

  const validateForm = (data = formData) => {
    let validationConfig = [
      {
        name: "email",
        validations: ["required", "email"],
      },
      {
        name: "mobile",
        validations: ["length"],
        min: 8,
      },
      {
        name: "accidentDesc",
        validations: ["required"],
      },
    ];

    return validateFields(validationConfig, data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);

    if (errors?.[name]) {
      validateForm(updated);
    }
  };

  const continueClickHanlder = () => {
    if (validateForm()) {
      saveMotorDataInRedux(formData);
      handleNextSubstep();
    }
  };
  return (
    <FileClaimMotorLayout btn_onClick={continueClickHanlder}>
      <div className="mx-auto bg-white max767:p-5 w-[500px] max-w-[100%]">
        <div className="max767:hidden">
          <TitleDescription
            title={t("motorInsurance.fileAClaimFlow.yourInfoPage.title")}
            description={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.description"
            )}
          />
        </div>
        <div className="max767:block hidden max767:mb-6">
          <TitleDescription
            title={t("motorInsurance.fileAClaimFlow.yourInfoPage.title")}
            description={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.mobile_description"
            )}
          />
        </div>
        <div>
          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.bodilyInjuryYourInfo.owner_cpr_number_label"
            )}
            type="number"
            handleChange={handleChange}
            name="ownerCpr"
            value={formData.ownerCpr}
            error={errors.ownerCpr}
            data-testid="ownerCpr"
          />

          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.email_address_label"
            )}
            type="text"
            handleChange={handleChange}
            name="email"
            value={formData.email}
            error={errors.email}
            data-testid="email"
          />
          <TelInput
            name="mobile"
            value={formData.mobile}
            error={errors.mobile}
            onChange={handleChange}
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.mobile_number_label"
            )}
            className="mobilenumber px-4 py-3 max767:w-[50%] w-[97%] border-r-0 border-0 rounded-[9px] h-[46px] focus:outline-none"
            data-testid="mobile"
          />
          <Input
            isTextarea
            label={t(
              "motorInsurance.fileAClaimFlow.accidentInfoPage.desc_accident_label"
            )}
            placeHolder={t(
              "motorInsurance.fileAClaimFlow.accidentInfoPage.desc_accident_placeholder"
            )}
            type="text"
            handleChange={handleChange}
            name="accidentDesc"
            value={formData.accidentDesc}
            error={errors.accidentDesc}
            data-testid="accidentDesc"
          />
        </div>
      </div>
    </FileClaimMotorLayout>
  );
}

export default BodilyInjuryYourInfo;
